var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-page includes-toc"},[_c('toc',{attrs:{"sections":_vm.sections}}),_c('section',[(_vm.$route.meta.desc)?_c('p',[_vm._v("\n      "+_vm._s(_vm.$route.meta.desc)+"\n    ")]):_vm._e(),_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }